import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Large, Small } from '@dbk/ui-text';
import format from 'date-fns/format';
import moment from 'moment';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemContent,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import Spinner from '@dbk/ui-spinner';
import { ROUTES, PALETTE, PAYMENT_STATUS,MULTISIGN_PAYMENT_STATUS, EBANKINGWEBLUX, RM_REGION, EBANKINGWEB, RM_REGION_CH,RM_REGION_UK, KEY_CODE, MULTISIGN_TAB_SELECT, PENDING_YOUR_APPROVAL} from '../../../../constants'
import { ScrollView, View } from '@dbk/ui-react-utils';
import paymentData from '../../../../data/paymenttypes.json';
import {Currency} from '../../../../components/common/number';
import styles, {centerSpinner}  from './index.styles';
import { ShortDate } from '@dbk/ui-dates';
import envConfig from '../../../../../db-env-build';
import Badge from '@dbk/ui-badge';
import { Tab, Tabs } from '@dbk/ui-tabs';
import Info from '@dbk/ui-icons/src/info';
import Info2 from '@dbk/ui-icons/src/info-2';
import Popover from '../../../../../src/components/popover-component/index';
import { PAYMENT_MODE } from '../../../../muster/app/payments/constant';

import { Settings } from '@dbk/ui-icons';
import PaymentFilter from '../payment-filter/payment-filter';
import PaymentMultiSignFilter from '../payment-multisign-filter';
import { formatShortMonthDayYear, formatShortMonthDayYearHour } from '../../../../utils/date';
const alignRightStyle = {flex: 1, alignItems: 'flex-end'};

class PaymentDashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pendingCount: 0,
    };
  }
  componentDidMount() {
    const { payments: { tabSelectedForMultiUser } } = this.props;
    //on language change send refetch (forceUpdate as per muster) to update the payments page as per language
    const prevLang=localStorage.getItem('PrevSelectedLanguage');
    const currentLang=localStorage.getItem('SelectedLanguage');
    const newPayFlg=localStorage.getItem('newPaymentComplete');
    const refetch=(prevLang!==currentLang && prevLang!==null)||newPayFlg || envConfig.rmRegion === RM_REGION || envConfig.rmRegion === RM_REGION_CH || envConfig.rmRegion === RM_REGION_UK ?'refetch':'';
    this.props.payments.setDisableTabs(false);
    this.props.payments.fetchPaymentList(tabSelectedForMultiUser);
    localStorage.setItem('PrevSelectedLanguage',localStorage.getItem('SelectedLanguage'));
    localStorage.removeItem('newPaymentComplete');

    this.props.payments.setIsMultiSigApprovalFlow(false);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.notifications.pendingPaymentCount) {
      this.setState({ pendingCount: this.props.notifications.pendingPaymentCount })
    }
    else {
      if (this.props.notifications.pendingPaymentCount !== prevProps.notifications.pendingPaymentCount) {
        this.setState({ pendingCount: this.props.notifications.pendingPaymentCount })
      }
    }
  }

  getPaymentTypeKey = paymentTypeName => {
    const defaultKey = paymentData.options[0].key
    const paymentTypeObj = paymentData.options.find(e => e.name===paymentTypeName)
    return paymentTypeObj ? paymentTypeObj.key : defaultKey
  }

  goSummary = (orderId, paymentType, paymentTypeDesc, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || ((paymentType || orderId) && !e)){
      this.props.payments.resetTemplateVariables();
      this.props.payments.fetchTx({ orderId, paymentType, paymentTypeDesc });
      this.props.changePage(ROUTES.PAYMENT.TX_SUMMARY);
    }
  }
  goSummaryForMultiSignApproval = (code,paymentUUID, paymentType, paymentTypeDesc,isApprovable, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || ((paymentType || orderId) && !e)){
      if((code.toUpperCase() === MULTISIGN_PAYMENT_STATUS.PENDING_APPROVAL || code.toUpperCase() == MULTISIGN_PAYMENT_STATUS.PARTIALLY_APPROVED) && isApprovable=='Y')
      {
        this.props.payments.resetTemplateVariables();
        this.props.payments.validateMultiSignPayment({ paymentUUID, paymentType, paymentTypeDesc });
        this.props.changePage(ROUTES.PAYMENT.TX_SUMMARY);
      } else {
        this.props.payments.resetTemplateVariables();
        this.props.payments.viewPaymentOrder({ paymentUUID, paymentType, paymentTypeDesc });
        this.props.changePage(ROUTES.PAYMENT.TX_SUMMARY);
      }
    }
  }
  handleSelectedIndexForMultiPayment = (index) =>{
      this.props.payments.setTabSelectedForMultiUser(index);
      this.props.payments.fetchPaymentList(index);
  }

  isRowDisabled = (code, isApprovable) => {
    if ((code.toUpperCase() === MULTISIGN_PAYMENT_STATUS.PENDING_APPROVAL || code.toUpperCase() == MULTISIGN_PAYMENT_STATUS.PARTIALLY_APPROVED ) && isApprovable=='Y') {
      return false;
    }else if( code.toUpperCase() === MULTISIGN_PAYMENT_STATUS.EXPIRED || code.toUpperCase() === MULTISIGN_PAYMENT_STATUS.REJECTED || code.toUpperCase() === MULTISIGN_PAYMENT_STATUS.ABORTED) {
      return false;
    }
    return true;
  }

  getBeneficiaryName =  (firstName, lastName) => {
    return (firstName||'')+(firstName&&lastName?' ':'')+(lastName||'')
  }

  getFormattedDate = (options, execKey, conclusionKey) => {
    return options?.[execKey]
    ? formatShortMonthDayYear(options[execKey])
    : options?.[conclusionKey]
      ? formatShortMonthDayYear(options[conclusionKey])
      : null;
  }
  render() {
    const {
      i18n: { messages } ,
      payments: {
        filterFlag,
        transactionListLoading: isLoading,
        transactionList,
        filteredPayments,
        multiSignPaymentList,
        signingType,
        tabSelectedForMultiUser,
        validateMultiSignPayment,
        multiSignFilteredPayments,
        multiSignFilterFlag
      }
    } = this.props;
    if(isLoading)
      return <View style={centerSpinner}><Spinner size="large"/></View>

    const data = filterFlag ? filteredPayments : transactionList;
    const multiSignData = multiSignFilterFlag ? multiSignFilteredPayments : multiSignPaymentList;

    const fromDate = this.getFormattedDate(this.props.payments.multiSignFilterOptions, 'execFromDate', 'conclusionFromDate');
    const toDate = this.getFormattedDate(this.props.payments.multiSignFilterOptions, 'execToDate', 'conclusionToDate');
    const submittedFromDate = this.getFormattedDate(this.props.payments.filterOptions, 'execFromDate', 'conclusionFromDate');
    const submiitedToDate = this.getFormattedDate(this.props.payments.filterOptions, 'execToDate', 'conclusionToDate');


    return (
      <React.Fragment>
        {/* tab for multiselect */}
        {signingType === PAYMENT_MODE.MULTI && (<View style={styles.categoryContainerTabs}>
          <Tabs
            stretch
            secondary
            handleSelectedIndex={(index) => 
              this.handleSelectedIndexForMultiPayment(index)
            }
            selectedIndex={tabSelectedForMultiUser}
          >
            <Tab
                renderLabel={() => (
                  <View 
                    style={styles.tabsForMultisig}
                  >
                    <Text size="large">
                      {messages['app.payments.multisig.submittedPayment']}
                    </Text>
                  </View>
                )}
              />
            <Tab
              renderLabel={() => (
                <View
                  style={styles.tabsForMultisig}
                >
                  <Text size="large">
                    {messages['app.payments.multisig.multiSigApproval']}
                  </Text>
                  <Badge className="category-tabs__tab--badge" value={this.state.pendingCount} />
                </View>
              )}
            />
            
          </Tabs>
        </View>)}
        {/* end tab for multiselect */}
        {tabSelectedForMultiUser === MULTISIGN_TAB_SELECT.SUBMITTED_PAYMENTS && (<div className="payment-dashboard">
          {this.props.payments.filterOptions?.selectedExecDate && submittedFromDate &&submiitedToDate &&
            <View className="margin-left-20 margin-top-10">
              <Text size="large" secondary>{messages['app.common.show']}</Text>
              <Text size="large" className="padding-left-5">{submittedFromDate}</Text>
              <Text size="large" secondary className="padding-left-5">{messages['app.payments.summary.to'].toLowerCase()}</Text>
              <Text size="large" className="padding-left-5">{submiitedToDate}</Text>
            </View>
          }
          <View className="payment-list-header">
              <NavigationListItemHeader>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payment.beneDetail.beneficiaryName']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.payment.beneDetail.paymentType']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payments.Iban.text']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.payment.beneDetail.executionDate']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.common.portfolio.fx.currency']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText} className="paymentListColumn paymentListCotent">{messages['app.report.transactionHistory.amount']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText} className="paymentListColumn paymentListCotent">{messages['app.documentUploadHistory.status']}</NavigationListItemContent>
              <PaymentFilter/>
              </NavigationListItemHeader>
            </View>
          <ScrollView>
            {(!data || !data.length) && (
              <View tabIndex={0}>
                <Large>{messages['app.payments.nopayment.message']}</Large>
              </View>
            )}
            {data.map(({
              orderId,
              paymentStatus,
              executionDate,
              beneficiaryDetails: {
                firstName: description,
                accountNo,
                ibanNo,
                bpId
              },
              paymentType: { paymentTypeName, paymentTypeDesc },
              currency: { isoCode },
              currency,
              debitAmount
            }) => {
              let color = PALETTE.paymentPending;
              const dwoStatus = paymentStatus ? paymentStatus.dwoStatus : PAYMENT_STATUS.PENDING
              if (dwoStatus.toUpperCase() === PAYMENT_STATUS.EXECUTED ) color = PALETTE.successIcon
              else if (dwoStatus.toUpperCase() === PAYMENT_STATUS.DELETED || dwoStatus.toUpperCase() === PAYMENT_STATUS.REVERSED || dwoStatus.toUpperCase() === PAYMENT_STATUS.REJECTED) color = PALETTE.primaryNegative
              const paymentTypeKey = this.getPaymentTypeKey(paymentTypeName)
              const execDate = format(new Date(executionDate), 'dd MMM yyyy');
              let statusDescription = ''
              if(paymentStatus) statusDescription = paymentStatus.statusDescription

              const currencyValue = isoCode !== "" && isoCode !== null ? isoCode : null;
              const formatter = new Intl.NumberFormat(this.props.auth.langCode);

              let formattedCurrency = "";
              if(currencyValue){    
                for(let i = 0; i < currencyValue.length; i++)
                  formattedCurrency += (currencyValue[i] + " ");
              }
              return (
                <NavigationListItem
                  key={orderId}
                  // role="listitem"
                  label={messages['app.accessibility.payment.paymentDetails']} // for arrow key to read out
                  tabIndex={-1}
                  inverse
                  onKeyDown={(e) => this.goSummary(orderId, paymentTypeKey, paymentTypeDesc, e)}
                  onClick={() => this.goSummary(orderId, paymentTypeKey, paymentTypeDesc)}
                  className="paymentListAccessible payment-transaction-list">
                  <NavigationListItemHeader>
                  { (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) && paymentTypeName === "INTERNAL_PAYMENT" ? <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent word-break"><Text className="pad-right-14">{bpId}</Text></NavigationListItemContent> :
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent word-break"><Text className="pad-right-14">{description}</Text></NavigationListItemContent>}
                    <NavigationListItemContent tabIndex={paymentTypeDesc? 0 : -1} className="paymentListColumn paymentListCotent paymentListWidth">{paymentTypeDesc}</NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent">{accountNo || ibanNo}</NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent"><ShortDate value={new Date(execDate)} /></NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent" aria-label={formattedCurrency}>{isoCode}</NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent">
                      {/* EBANK-13231 : Number representation in German  */}
                    { Object.keys(currency).length !== 0 && currencyValue !== null && debitAmount !== null ?
                      <span>
                        <Currency
                            value={debitAmount}
                            renderProps={{
                              size: 'small',
                              style: styles.currencyColor
                            }}
                          />
                      </span>
                      :
                      <span tabIndex="0"><Small>{formatter.format(debitAmount)}</Small></span>
                      }</NavigationListItemContent>
                    <NavigationListItemContent  className="paymentListColumn paymentListCotent" tabIndex={0} color={color}>{statusDescription}</NavigationListItemContent>
                  </NavigationListItemHeader>
                </NavigationListItem>
              )
            })}
          </ScrollView>
        </div>)}
        {/* Multi-Signature Approvals list start */}
        {tabSelectedForMultiUser === MULTISIGN_TAB_SELECT.MULTISIG_APPROVALS && (<div className="payment-dashboard">
          {this.props.payments.multiSignFilterOptions?.selectedExecDate && fromDate && toDate &&
            <View className="margin-left-20 margin-top-10">
              <Text size="large" secondary>{messages['app.common.show']}</Text>
              <Text size="large" className="padding-left-5">{fromDate}</Text>
              <Text size="large" secondary className="padding-left-5">{messages['app.payments.summary.to'].toLowerCase()}</Text>
              <Text size="large" className="padding-left-5">{toDate}</Text>
            </View>
          }
                   
          <View className="payment-list-header">
              <NavigationListItemHeader>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payment.beneDetail.beneficiaryName']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent">{messages['app.payments.Iban.text']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.payment.beneDetail.executionDate']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.common.portfolio.fx.currency']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.report.transactionHistory.amount']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn accordionContent"> {messages['app.payments.multisig.approvalStatus']}</NavigationListItemContent>
              <NavigationListItemContent tabIndex="0" role="presentation" color={PALETTE.primaryText}  className="paymentListColumn paymentListCotent">{messages['app.payments.expirationDate.text']}</NavigationListItemContent>
              <PaymentMultiSignFilter/>
              </NavigationListItemHeader>
            </View>
          <ScrollView>
            {(!multiSignData || !multiSignData.length) && (
              <View tabIndex={0}>
                <Large>{messages['app.payments.nopayment.message']}</Large>
              </View>
            )}
            {multiSignData && multiSignData.map(({
              paymentUUID,
              paymentType: {
                paymentTypeId,
                paymentTypeDesc,
                paymentTypeName
              },
              executionDate,
              expiryTS,
              paymentAmount,
  
              beneficiaryDetails: {
                firstName,
                lastName,
                accountNo,
                bpId,
                ibanNo
              },
              currency: { isoCode },
              isApprovable,
              
              signingStatus: {
                code,
                description,
                
            }
            }) => {
              
              let color = PALETTE.primaryText;
              if (code) {
                switch (code.toUpperCase()) {
                  case MULTISIGN_PAYMENT_STATUS.EXECUTED:
                    color = PALETTE.successIcon;
                    break;
                  case MULTISIGN_PAYMENT_STATUS.PARTIALLY_APPROVED:
                  case MULTISIGN_PAYMENT_STATUS.PENDING_APPROVAL:
                    if (isApprovable && isApprovable.toUpperCase() === 'Y') {
                      color = PALETTE.paymentPending;
                    }
                    break;
                  case MULTISIGN_PAYMENT_STATUS.EXPIRED:
                  case MULTISIGN_PAYMENT_STATUS.REJECTED:
                  case MULTISIGN_PAYMENT_STATUS.ABORTED:
                    color = PALETTE.primaryNegative;
                    break;
                  default:
                    color = PALETTE.primaryText;
                    break;
                }
              }

              const paymentTypeKey = this.getPaymentTypeKey(paymentTypeName)
              const execDate = formatShortMonthDayYear(executionDate)

              const expTsDate = formatShortMonthDayYearHour(expiryTS)
              const isPendingOtherApproval = this.isRowDisabled(code, isApprovable);
              const beneficiaryName = this.getBeneficiaryName(firstName, lastName);
              let formattedCurrency = "";
              return (
                <NavigationListItem
                  key={paymentUUID}
                  // role="listitem"
                  label={messages['app.accessibility.payment.pendingApprovalDetails']} // for arrow key to read out
                  tabIndex={-1}
                  inverse
                  onKeyDown={(e) => this.goSummaryForMultiSignApproval(code,paymentUUID, paymentTypeKey, paymentTypeDesc,isApprovable,e)}
                  onClick={() => this.goSummaryForMultiSignApproval(code,paymentUUID, paymentTypeKey, paymentTypeDesc, isApprovable)}
                  style={{ backgroundColor: isPendingOtherApproval ? '#0E1B34' : '#12213C'}}
                  className="paymentListAccessible payment-transaction-list">
                  <NavigationListItemHeader>
                  { (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) && paymentTypeName === "INTERNAL_PAYMENT" ? <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent" color ={isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive}>{bpId}</NavigationListItemContent> :
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent">
                      <Text className='wrap-text' style={{color: isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive}}>{beneficiaryName}</Text>
                      </NavigationListItemContent>}
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn accordionContent">
                     <Text className='wrap-text' style={{color: isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive}}>{accountNo || ibanNo }</Text> </NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent"  color ={isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive}  >
                      {execDate}
                      </NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent" aria-label={formattedCurrency} color ={isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive} >{isoCode}</NavigationListItemContent>
                    <NavigationListItemContent tabIndex={0} className="paymentListColumn paymentListCotent">
                      {/* EBANK-13231 : Number representation in German  */}
                      <span>
                        <Currency
                            value={+paymentAmount}
                            renderProps={{
                              size: 'small',
                              style: {'color': isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive}
                            }}
                          />
                      </span>
                      </NavigationListItemContent>
                    <NavigationListItemContent  className="paymentListColumn accordionContent" tabIndex={0} color ={isPendingOtherApproval ? PALETTE.primaryText : color}>{description? description.toUpperCase() : '-'}</NavigationListItemContent>
                    <NavigationListItemContent  className="paymentListColumn paymentListCotent" tabIndex={0} color ={isPendingOtherApproval ? PALETTE.primaryText : PALETTE.secondaryActive} >{expiryTS ? expTsDate: expiryTS}</NavigationListItemContent>
                  </NavigationListItemHeader>
                </NavigationListItem>
              )
            })}
          </ScrollView>
        </div>)}
        {/* Multi-Signature Approvals list end */}
      </React.Fragment>
    )
  }
}
export default createContainer({
  $renderLoading: () => <Spinner size="large"/>,
  $queries: {
    i18n: {
      messages: true
    },
    payments: {
      getPaymentHistory: { $call: 'getPaymentHistory' },
      signingType: true,
      tabSelectedForMultiUser: true,
      setTabSelectedForMultiUser: {$set: 'tabSelectedForMultiUser'},
      multiSignPaymentList: true,
      setIsMultiSigApprovalFlow: {$set: 'isMultiSigApprovalFlow'},
      validateMultiSignPayment: {$call: 'validateMultiSignPayment'},
      viewPaymentOrder: {$call: 'viewPaymentOrder'},
      fetchTx: { $call: 'fetchTx' },
      transactionList: true,
      transactionListLoading: true,
      filteredPayments: true,
      filterFlag: true,
      disableTabs:true,
      setDisableTabs: { $set: 'disableTabs'},
      resetTemplateVariables: { $call: 'resetTemplateVariables'},
      multiSignFilteredPayments: true,
      multiSignFilterFlag: true,
      multiSigNotificationDetails: true,
      multiSignFilterOptions: true,
      fetchPaymentList: { $call: 'fetchPaymentList'},
      filterOptions: true
    },
    notifications: {
            dataNotification: true,
            pendingPaymentCount: true
        },
    changePage: { $call: 'ui.history.push' },
    auth: {
      langCode: true
    }
  }
})(PaymentDashboard);
